import H from 'history'
import { BaseTheWestWeb } from './BaseTheWest.web'

import {
    createRenderTarget,
    ProviderChildProps,
} from '@news-mono/component-library'
import loadable from '@loadable/component'
import { SiteProps } from '../Site'
import { Product } from '@news-mono/web-common'

export interface BaseTheWestProps extends SiteProps {
    location: H.Location
    flyOutProps: ProviderChildProps
    product: Product
}
const LazyBaseTheWestAmp = loadable(() => import('./BaseTheWest.amp'))

export const BaseTheWest = createRenderTarget<BaseTheWestProps>('BaseTheWest', {
    web: BaseTheWestWeb,
    amp: LazyBaseTheWestAmp,
    preview: BaseTheWestWeb,
    rss: BaseTheWestWeb,
    app: BaseTheWestWeb,
})
